import { useQuery } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import toastr from 'react-hot-toast'
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index'
import { generateURL } from 'utilities/hooks/urlGeneration'
import { SPARK_RESOURCE_TYPES } from 'constants/common'
import type {
  SubscriptionTypeResponse,
  SubscriptionType,
} from 'types/entityTypes/SubscriptionType'

const getSubscriptionType = () => {
  const url = generateURL(SPARK_RESOURCE_TYPES.SUBSCRIPTION_TYPE)
  return fetchWrapper<SubscriptionTypeResponse>({
    url: url,
    method: 'GET',
  })
}

export function useSubscriptionTypes() {
  const response = useQuery('subscriptionType', getSubscriptionType, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Fetch subscription types: ${error.message}`)
      }
    },
    ...INFINITE_CACHE_AND_STALE_TIME,
  })

  const { data: subscriptionTypes } = response.data || {}

  const idMap = subscriptionTypes?.reduce<Record<string, SubscriptionType>>(
    (acc, curr) => {
      return { ...acc, [curr.id]: curr }
    },
    {}
  )

  const nameByIdMap = subscriptionTypes?.reduce<Record<string, string>>(
    (acc, curr) => {
      return { ...acc, [curr.id]: curr.attributes.name }
    },
    {}
  )

  return {
    subscriptionTypes,
    idMap,
    nameByIdMap,
    ...response,
  }
}
